<template>
  <div class="d-flex pa-2 rounded" 
    :style="{'background-color': color, 'max-width': '360px', 'height': '86px', 'column-gap': '8px' }" 
    @click="onClick"
  >
    <div :style="enabledStyles">
      <v-img 
        v-if="badge.image_url" 
        :src="badge.image_url" 
        width="70px" max-width="70px"
      />
      <div v-else style="width: 70px; max-width: 70px"></div>
    </div>
    
    <div class="d-flex flex-column flex-grow-1 mx-1 mt-n1 justify-center">
      <div style="font-size: 16px"><strong>{{ badge.title }}</strong></div>
      <div style="line-height: 1.4; font-size: 14px;">{{ badge.description }}</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Badge',

    props: ['badge'],

    computed: {
      color() {
        return this.badge.awarded ? this.badge.color : '#BDBDBD'
      },

      enabledStyles() {
        if (this.badge.awarded) 
          return { }
    
        return { filter: 'grayscale(1)' }
      }
    },

    methods: {
      onClick() {
        this.$emit('click')
      },
    },
  }
</script>